

(function () {
  'use strict';

  if (document.body.getAttribute('data-ymal-bound') === '1') return;
  document.body.setAttribute('data-ymal-bound', '1');

  function getVariantId(card) {
    var select = card.querySelector('.variant-select');
    if (select && select.value) return select.value;
    var btn = card.querySelector('.ymal-add-btn');
    return btn ? btn.getAttribute('data-variant-id') : null;
  }

  function onYmalChange(e) {
    if (!e.target.classList.contains('variant-select')) return;
    var select = e.target;
    var card = select.closest('.cartproduct-card');
    if (!card) return;
    var opt = select.options[select.selectedIndex];
    var btn = card.querySelector('.ymal-add-btn');
    if (btn) btn.setAttribute('data-variant-id', select.value);
    var priceEl = card.querySelector('.cart_product-price');
    if (priceEl && opt && opt.dataset.price) {
      priceEl.innerHTML = 'Starting at ' + opt.dataset.price;
    }
  }

  function onYmalClick(e) {
    var btn = e.target.closest('.ymal-add-btn');
    if (!btn) return;
    if (btn.getAttribute('data-busy') === '1') return;

    e.preventDefault();
    e.stopPropagation();

    var card = btn.closest('.cartproduct-card');
    var variantId = getVariantId(card);
    if (!variantId) return;

    var label = btn.textContent.trim();
    btn.setAttribute('data-busy', '1');
    btn.disabled = true;
    btn.textContent = 'Adding...';

    function reset(text) {
      setTimeout(function () {
        btn.textContent = text || label;
        btn.disabled = false;
        btn.setAttribute('data-busy', '0');
      }, 2000);
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
    .then(function (r) {
      if (!r.ok) throw new Error('add failed');
      btn.textContent = '✓ Added!';

      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
           var displayCount = cart.items.reduce(function (sum, item) {
      if (item.properties && item.properties._is_cut_fee === 'true') return sum;
      return sum + item.quantity;
    }, 0);

    document.querySelectorAll('.cart-count-bubble span').forEach(function (el) {
      el.textContent = displayCount;
    });

    // Also show/hide the bubble wrapper itself
    var bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
    if (bubble) bubble.style.display = displayCount === 0 ? 'none' : '';
        })
        .catch(function () {});

      fetch('/?sections=cart-drawer')
        .then(function (r) { return r.json(); })
        .then(function (sections) {
          if (!sections || !sections['cart-drawer']) return;
          var tmp = document.createElement('div');
          tmp.innerHTML = sections['cart-drawer'];
          [
            '#CartDrawer-CartItems',
            '.cart-drawer__cart-items-wrapper',
            '#CartDrawer-Footer',
            '.cart-drawer__footer'
          ].forEach(function (sel) {
            var n = tmp.querySelector(sel);
            var o = document.querySelector(sel);
            if (n && o) o.innerHTML = n.innerHTML;
          });
        })
        .catch(function () {});

      reset(label);
    })
    .catch(function () {
      btn.textContent = 'Error — try again';
      reset(label);
    });
  }

  document.addEventListener('change', onYmalChange);
  document.addEventListener('click', onYmalClick);

  // ── Hide YMAL when cart becomes empty, show when items exist ──
function syncYmalVisibility() {
  fetch('/cart.js', { cache: 'no-store' })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var ymal = document.querySelector('.cart-youalsolike-main');
      if (!ymal) return;
      ymal.style.display = cart.item_count === 0 ? 'none' : '';
    })
    .catch(function () {});
}

// Run once on load (handles page-refresh-with-empty-cart edge case)
document.addEventListener('DOMContentLoaded', syncYmalVisibility);

// Run after every cart change (add, remove, quantity update)
document.addEventListener('DOMContentLoaded', function () {
  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      setTimeout(syncYmalVisibility, 150); // small delay so Dawn finishes its DOM update first
    });
  }
});
})();
